export default {
  title: 'Payer avec Pix',
  hint: 'Copiez le code et collez-le dans Pix dans votre appli bancaire, ou scannez le QR code avec elle.',
  copy: 'Copier le code Pix',
  copied: 'Code copié',
  qr_alt: 'QR code Pix',
  expires_in: 'Le code expire dans {{time}}',
  waiting: 'Nous confirmerons votre commande dès que votre banque enverra le paiement.',
  open_page: 'Ouvrir la page de paiement à la place',
  expired: 'Ce code Pix a expiré. Recommencez le paiement pour en obtenir un nouveau.',
  cancel: 'Annuler le paiement',
  checking: 'Vérification de votre paiement…',
  close: 'Fermer',
};
